import { render, staticRenderFns } from "./CardBank.vue?vue&type=template&id=4534d87c&scoped=true"
import script from "./CardBank.vue?vue&type=script&lang=js"
export * from "./CardBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4534d87c",
  null
  
)

export default component.exports